import React from 'react';
import { getAssetIcon } from 'utils/icons';
import Icon from 'components/Icon';
import CardImage from 'components/CardImage';
function renderItemThumbnail(item) {
  var icon = getAssetIcon(item);
  return /*#__PURE__*/React.createElement(CardImage, {
    src: item.pictureUrl && "".concat(item.pictureUrl, "/w_58,h_40"),
    width: 58,
    aspectRatio: 2 / 3,
    colorBlock: icon,
    fallbackContent: /*#__PURE__*/React.createElement(Icon, {
      dimmed: true,
      name: icon
    })
  });
}
export default renderItemThumbnail;